import { render, staticRenderFns } from "./RegistrationBlock.vue?vue&type=template&id=b367db1a"
import script from "./RegistrationBlock.vue?vue&type=script&lang=js"
export * from "./RegistrationBlock.vue?vue&type=script&lang=js"
import style0 from "./RegistrationBlock.vue?vue&type=style&index=0&id=b367db1a&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b367db1a')) {
      api.createRecord('b367db1a', component.options)
    } else {
      api.reload('b367db1a', component.options)
    }
    module.hot.accept("./RegistrationBlock.vue?vue&type=template&id=b367db1a", function () {
      api.rerender('b367db1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/invention/RegistrationBlock.vue"
export default component.exports